/**
 * What of a live thought summary to show: the heading of the section the model
 * is in now, or null before the first one has arrived.
 *
 * Gemini streams its reasoning as a run of short sections, each opening with a
 * bold title — `**Distinguishing Salami Types**` — followed by a paragraph of
 * first-person prose. The paragraphs are thousands of characters over a turn
 * and read as noise in a two-line spinner; the titles are three or four words
 * and change every few seconds, which is exactly the "it is getting somewhere"
 * signal the card exists for.
 *
 * Only a COMPLETE `**…**` pair counts, so a title still arriving mid-delta is
 * not shown half-typed.
 */
export const thoughtHeadline = (text: string): string | null => {
  let last: string | null = null;
  for (const match of text.matchAll(/\*\*([^*\n]+)\*\*/g)) {
    const title = match[1].trim().replace(/[.:]+$/, "");
    if (title) last = title;
  }
  return last;
};
